import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import QuickAddModal from './QuickAddModal';
import GlobalSearch from './GlobalSearch';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isQuickAddOpen, setIsQuickAddOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const navigationItems = [
    { id: 'dashboard', label: 'Dashboard', path: '/main-operations-dashboard', icon: 'LayoutDashboard' },
    { id: 'enhanced-dashboard', label: 'Alerts', path: '/enhanced-dashboard-home-with-alert-management', icon: 'Bell' },
    { id: 'properties', label: 'Properties', path: '/properties-management-screen', icon: 'Building2' },
    { id: 'certificates', label: 'Certificates', path: '/smart-certificate-expiry-management', icon: 'ShieldCheck' },
    { id: 'maintenance', label: 'Maintenance', path: '/maintenance-kanban-workflow-board', icon: 'Wrench' },
    { id: 'tenancies', label: 'Tenancies', path: '/tenant-onboarding-management-screen', icon: 'Users' },
    { id: 'reports', label: 'Reports', path: '/comprehensive-reports-analytics-dashboard', icon: 'BarChart3' },
  ];

  const currentDate = new Date()?.toLocaleDateString('en-GB', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    // No-op
  };

  const isActive = (path) => {
    return location?.pathname === path;
  };

  return (
    <>
      <header className="nav-header">
        <div className="utility-bar">
          <div className="utility-bar-logo">
            <div className="utility-bar-logo-icon">
              <Icon name="Building2" size={24} color="var(--color-accent)" />
            </div>
            <div>
              <h1 className="text-lg font-semibold text-foreground font-heading">LetOps Dashboard</h1>
              <p className="text-xs text-muted-foreground font-caption">{currentDate}</p>
            </div>
          </div>

          <div className="utility-bar-actions">
            <Button
              variant="default"
              size="default"
              iconName="Plus"
              iconPosition="left"
              onClick={() => setIsQuickAddOpen(true)}
            >
              Quick Add
            </Button>

            <button
              onClick={() => setIsSearchOpen(true)}
              className="h-12 w-12 rounded-lg bg-input border border-border flex items-center justify-center transition-smooth hover:bg-muted"
              aria-label="Search"
            >
              <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
            </button>
          </div>
        </div>

        <nav className="tab-navigation">
          {navigationItems?.map((item) => (
            <button
              key={item?.id}
              onClick={() => handleNavigation(item?.path)}
              className={`tab-item ${isActive(item?.path) ? 'active' : ''}`}
              aria-current={isActive(item?.path) ? 'page' : undefined}
            >
              <Icon name={item?.icon} size={18} />
              <span>{item?.label}</span>
            </button>
          ))}
        </nav>
      </header>
      <QuickAddModal
        isOpen={isQuickAddOpen}
        onClose={() => setIsQuickAddOpen(false)}
        defaultModule={location?.pathname}
      />
      <GlobalSearch
        isOpen={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
      />
    </>
  );
};

export default Header;